"use client";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function ContactPage() {
  return (
    <><Navbar /><main className="text-gray-800 bg-white dark:bg-neutral-900 dark:text-white">
      {/* Header Section */}
      <section className="px-6 py-20 text-center">
        <h1 className="mb-4 text-4xl font-bold text-blue-800">Get in Touch</h1>
        <p className="max-w-2xl mx-auto text-lg text-gray-600 dark:text-neutral-400">
          We'd love to hear from you. Whether you have questions, suggestions, or need assistance—our team is here for you.
        </p>
      </section>

      {/* Contact Form and Info */}
      <section className="grid max-w-6xl grid-cols-1 gap-12 px-6 pb-20 mx-auto md:grid-cols-2">
        {/* Form */}
        <form className="space-y-6">
          <div className="grid gap-4 sm:grid-cols-2">
            <input
              type="text"
              placeholder="First Name"
              className="w-full p-3 border border-gray-300 rounded-lg dark:bg-neutral-800" />
            <input
              type="text"
              placeholder="Last Name"
              className="w-full p-3 border border-gray-300 rounded-lg dark:bg-neutral-800" />
          </div>
          <input
            type="email"
            placeholder="Email"
            className="w-full p-3 border border-gray-300 rounded-lg dark:bg-neutral-800" />
          <input
            type="text"
            placeholder="Phone Number"
            className="w-full p-3 border border-gray-300 rounded-lg dark:bg-neutral-800" />
          <textarea
            rows={4}
            placeholder="How can we help you?"
            className="w-full p-3 border border-gray-300 rounded-lg dark:bg-neutral-800" />
          <button
            type="submit"
            className="w-full px-6 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700"
          >
            Send Message
          </button>
        </form>

        {/* Contact Info */}
        <div className="space-y-8">
          <div>
            <h3 className="text-xl font-semibold text-blue-800">Address</h3>
            <p>Harmony School, 123 Learning Lane, Lagos, Nigeria</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-blue-800">Phone</h3>
            <p>+234 800 123 4567</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-blue-800">Email</h3>
            <p>contact@harmonyschool.ng</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold text-blue-800">Office Hours</h3>
            <p>Mon - Fri: 8:00 AM – 4:00 PM</p>
          </div>
        </div>
      </section>

      {/* FAQ/Help Cards */}
      <section className="py-16 bg-blue-50 dark:bg-neutral-800">
        <div className="max-w-6xl px-6 mx-auto text-center">
          <h2 className="mb-8 text-2xl font-bold text-blue-800">Still need help?</h2>
          <div className="grid gap-6 text-left md:grid-cols-3">
            {[
              {
                title: "Frequently Asked Questions",
                desc: "Find answers to the most common inquiries from parents and students.",
                link: "#",
              },
              {
                title: "Technical Support",
                desc: "Facing issues with your portal or school app? We're here to help.",
                link: "#",
              },
              {
                title: "Enrollment Help",
                desc: "Need guidance on the enrollment process? We’ve got you covered.",
                link: "#",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="p-6 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-neutral-900 dark:border-neutral-700"
              >
                <h3 className="text-lg font-semibold text-blue-700">{item.title}</h3>
                <p className="my-2 text-sm text-gray-600 dark:text-neutral-400">
                  {item.desc}
                </p>
                <a href={item.link} className="text-sm text-blue-600 hover:underline">
                  Learn more →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
    <Footer/>
    </>
  );
}
